import ApprovalApi from './approval.api'

export default ApprovalApi
